// extracted by mini-css-extract-plugin
export default {"group":"ConversationRowGroup_group__Zb-Da","bottomGroup":"ConversationRowGroup_bottomGroup__r2JCs"};